import AppEnvironment from '../../../components/enums/appEnvironment.enum';
import { loggedAsBrand } from '../../context/contextUtils';
import { OfflineStatus } from '../../offline/domain/offlineOrder/offlineOrder.types';
import { StatusType } from '../order.types';
import { Filter } from './filterActions';
import { SummaryAction, allSummaryActions } from './orderSummaryActions';
import { GetActionsParams, PrimaryActionParams, Role } from './types/actions.types';
import { ActionEnum, OrderAction } from './types/orderActions.types';

class OrderActions {
  private primaryAction?: SummaryAction;

  private primaryActionDraft({ role }: PrimaryActionParams): SummaryAction | undefined {
    if (role === Role.ADMIN_LOJA || role === Role.COMPRADOR) {
      return ActionEnum.FINISH_TO_IN_REVISION;
    }
    return ActionEnum.FINISH_TO_ON_APPROVAL;
  }

  private primaryActionInRevision({ role }: PrimaryActionParams): SummaryAction | undefined {
    const isBrand = role ? ['VENDEDOR', 'ADMIN_MARCA'].includes(role) : false;
    if (isBrand) {
      return ActionEnum.FINISH_TO_ON_APPROVAL;
    }
    return undefined;
  }

  private primaryActionOfflineStatus({
    role,
    userHasInternet,
  }: PrimaryActionParams): SummaryAction | undefined {
    if (!loggedAsBrand(role)) {
      return;
    }

    return userHasInternet ? ActionEnum.SYNC_OFFLINE_ORDER : ActionEnum.EXPORT_ORDER;
  }

  private primaryActionOnApproval({ role }: PrimaryActionParams): SummaryAction | undefined {
    if (role === Role.ADMIN_MARCA) {
      return ActionEnum.FINISH_TO_APPROVED;
    }
    return undefined;
  }

  getActions(params: GetActionsParams): OrderAction[] {
    const filter = new Filter();
    filter.filterActions(params, false);
    return filter.getActions();
  }

  getMassActions(params: GetActionsParams): OrderAction[] {
    const filter = new Filter();
    filter.filterActions(params, true);
    return filter.getActions();
  }

  getPrimaryAction(params: PrimaryActionParams): OrderAction | undefined {
    if (params.appEnvironment === AppEnvironment.STORE) {
      return undefined;
    }

    switch (params.status) {
      case StatusType.DRAFT:
        this.primaryAction = this.primaryActionDraft(params);
        break;
      case StatusType.IN_REVISION:
        this.primaryAction = this.primaryActionInRevision(params);
        break;
      case StatusType.ON_APPROVAL:
        this.primaryAction = this.primaryActionOnApproval(params);
        break;
      case OfflineStatus.OFFLINE:
      case OfflineStatus.ERROR_SYNCING:
        this.primaryAction = this.primaryActionOfflineStatus(params);
        break;
      default:
        break;
    }

    if (this.primaryAction) {
      return {
        icon: allSummaryActions[this.primaryAction].icon,
        label: allSummaryActions[this.primaryAction].label,
        value: allSummaryActions[this.primaryAction].value,
      };
    }
  }
}

export { OrderActions };
